import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Short from 'Components/Format/DateFormat/Short';
import EditButtonLink from 'Components/Blueprint/UI/EditButtonLink';
import ImageHeading from '../ImageHeading';

const AdvancedHealthcareDirectives = ({ advancedHealthcareDirectives, editLink }) => (
  <td className="advanced-healthcare-directives">
    <ImageHeading className="advanced-healthcare-directive">
      Adv. Healthcare Directive
      {editLink && (<EditButtonLink
        title="Edit Adv. Healthcare Directive"
        to={editLink}
      />)}
    </ImageHeading>
    {advancedHealthcareDirectives.length > 0 ? (
      advancedHealthcareDirectives.map(advancedHealthcareDirective => (
        <div
          className="advanced-healthcare-directive item"
          key={`${advancedHealthcareDirective.id}ahd`}
        >
          <div className="name">
            {advancedHealthcareDirective.attributes.principal}
          </div>
          {advancedHealthcareDirective.attributes.dateExecuted !== '' && (
            <div>
              Executed:&nbsp;
              <Short
                date={advancedHealthcareDirective.attributes.dateExecuted}
              />
            </div>
          )}
          {advancedHealthcareDirective.attributes.stateExecuted !== '' && (
            <div>
              State:&nbsp;
              {advancedHealthcareDirective.attributes.stateExecuted}
            </div>
          )}
          {advancedHealthcareDirective.attributes.primaryAgent !== '' && (
            <div>
              Primary:&nbsp;
              {advancedHealthcareDirective.attributes.primaryAgent}
            </div>
          )}
          {advancedHealthcareDirective.attributes.successorAgent !== '' && (
            <div>
              Successor:&nbsp;
              {advancedHealthcareDirective.attributes.successorAgent}
            </div>
          )}
        </div>
      ))
    ) : (
      <Fragment>
        <p>No advanced healthcare directives.</p>
      </Fragment>
    )}
  </td>
);

AdvancedHealthcareDirectives.propTypes = {
  advancedHealthcareDirectives: PropTypes.array.isRequired,
  editLink: PropTypes.string,
};
AdvancedHealthcareDirectives.defaultProps = {
  editLink: null,
};

export default AdvancedHealthcareDirectives;
